import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import React from "react";
import styles from "./DatagridExportButton.module.sass";
import Connect from "colbi_web_ui/lib/components/Connect";
import { SovosBox, SovosIconButton } from "mosaic-react";
import { Download } from "mosaic-react-icons";

const DatagridExportButton = (props) => {
    const {
        data,
        exportableArray = [],
        alternativeQueryData,
        modalToUse = "DatagridMultipleDownloadDialog",
    } = props;
    const { download, downloadableQueries, locale, i18n, totalLinesCsv, pushDialog, downloadFile } =
        useGlobalValue();
    return (
        <Connect to={["search", "downloading"]}>
            {({ downloading }) => (
                <SovosBox>
                    {downloadableQueries && downloadableQueries.length > 1 && downloading ? (
                        <SovosBox className={styles["backdrop"]}>
                            <SovosBox className={`${styles["loader"]}`} />
                        </SovosBox>
                    ) : null}
                    <SovosBox>
                        {data && data.length ? (
                            <SovosBox className={`${styles["export-button"] || ""}`}>
                                {!exportableArray.length &&
                                (alternativeQueryData ||
                                    (downloadableQueries && downloadableQueries.length === 1)) ? (
                                    <SovosIconButton
                                        tooltipText={"Download"}
                                        children={<Download style={{ fill: "#545E75" }} />}
                                        className={`${styles["action-button"]} ${
                                            downloading ? styles["has-activity"] : ""
                                        }`}
                                        onClick={() => {
                                            download &&
                                                download(
                                                    alternativeQueryData || downloadableQueries,
                                                    locale,
                                                );
                                        }}
                                    />
                                ) : (
                                    <SovosIconButton
                                        tooltipText={"Download"}
                                        children={<Download style={{ fill: "#545E75" }} />}
                                        onClick={() => {
                                            !downloading &&
                                                pushDialog(
                                                    modalToUse,
                                                    i18n`Chose donwload options`,
                                                    {
                                                        queries:
                                                            exportableArray &&
                                                            exportableArray.length
                                                                ? exportableArray.map((elem) => ({
                                                                      ...(alternativeQueryData
                                                                          ? alternativeQueryData
                                                                          : downloadableQueries.length
                                                                            ? downloadableQueries[0]
                                                                            : {}),
                                                                      exportableEntity: elem,
                                                                  }))
                                                                : downloadableQueries,
                                                        download,
                                                        locale,
                                                        totalLinesCsv,
                                                        downloadFile,
                                                        pushDialog,
                                                    },
                                                )
                                                    .then(() => {})
                                                    .catch(() => null);
                                        }}
                                    />
                                )}
                            </SovosBox>
                        ) : null}
                    </SovosBox>
                </SovosBox>
            )}
        </Connect>
    );
};

export default DatagridExportButton;
